import {GameModeTransitionControllerWithView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionControllerWithView";
import {HorribleHeroesParsedInitData} from "../../server/data/HorribleHeroesParsedInitData";

// #370
export class HHRestoreDuringFreeSpinController extends GameModeTransitionControllerWithView {

    // #370 -> not using super's call here as we only need this to run for a restore done during FreeSpin rounds.
    protected calculateIsTriggeredThisSpin(data: HorribleHeroesParsedInitData): boolean {
        return data.isRestoreState && data.nextMode == this._toMode;
    }
}